import Button from "../../../Components/UI/Button/Button";
import useHttpFetch from "../../../hooks/useHttpFetch";
import classe from "./DargahpardakhtSaman.module.css";

function generateUniqueId() {
  return `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
}

const DargahpardakhtSaman = () => {
  const { isLoading, sendRequest } = useHttpFetch();

  const submitHandler = async () => {
    const result = await sendRequest({
      noMiddleUrl: true,
      url: `networkMarketer/getToken/Saman`,
      method: "POST",
      body: {
        amount: 10000,
        resNum: generateUniqueId(),
        redirectUrl: "https://servercmit.lafarrerr.com:8082/networkMarketer/checkPayment/Saman",
        cellphone: "09124850186",
      },
    });

    if (result.resIsOk && result.resStatus === 200 && result.response?.message) {
      window.location.href = `https://sep.shaparak.ir/OnlinePG/SendToken?token=${result.response.message}`;
    }
  };

  return (
    <div className={classe.container}>
      <h2>خوش آمدید , برای تست روی دکمه زیر کلیک کنید</h2>
      <Button
        isLoading={isLoading}
        largeWidth={true}
        notTranslationalTxt="پرداخت"
        onClick={submitHandler}
        style="confirm"
      />
    </div>
  );
};

export default DargahpardakhtSaman;
